import { celo as viemCelo } from 'viem/chains';

import { defaultServices } from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const celo = {
  displayName: 'Celo',
  runtime: 'evm',
  viemChain: viemCelo,
  isSupported: false,
  isMainnet: true,
  services: defaultServices({
    zerion: { chainKey: 'celo' },
    qnStreams: {
      networkKey: 'celo-mainnet',
    },
    pimlico: { chainSlug: 'celo' },
  }),
} as const satisfies AllChainConfig<'evm', false>;
